module.exports = __webpack_public_path__ + "img/skinbox-sale.1d720ad1.png";